import { render, staticRenderFns } from "./lkuDim.vue?vue&type=template&id=2c455a49"
import script from "./lkuDim.vue?vue&type=script&lang=js"
export * from "./lkuDim.vue?vue&type=script&lang=js"
import style0 from "./lkuDim.vue?vue&type=style&index=0&id=2c455a49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports